import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as Arrow2 } from '../../assets/icons/arrows/arr074.svg';
import { ReactComponent as Logout } from '../../assets/icons/menu/logout.svg';
import AuthContext from '../../context/authContext';
import './menuLinks.scss';
import axios from "../../api/axios-config";

const MenuLinks = ({ link, icon, title, image }) => {
    return (
        <Link to={link} className={`menu-link ${window.location.pathname.includes(link) ? " bg-bs-dark-green !text-white" : ""} `}>
            <span className='menu-icon'>
                {
                    image ?
                    <img src={image} alt={title} className='!w-[75px]' width={"75px"}  style={{minWidth:"18px"}}/>
                        :
                    icon
                }
            </span>
            <div className={`menu-link-detail`}>
                <p>{title}</p>
                <Arrow2 />
            </div>
        </Link>
    )
}
const LogoutMenu = (props) => {

    const auth = useContext(AuthContext);
    

    const onClickedHandler =  async () => {
        const token = JSON.parse(localStorage.getItem("za_token"))
        let {data} = await axios.post("/super-admin/logout",token)
        localStorage.removeItem("za_token")
        window.open('https://zibaeslami.com', "_self")
        return data;
    }
    return (
        <div onClick={() => onClickedHandler()} className='menu-link'>
            <span className='menu-icon'>
                <Logout width={"19.5"} height="19.5" fill='#5d5d5d' />
            </span>
            <div className={`menu-link-detail`}>
                <p>{props.title}</p>
                <Arrow2 />
            </div>
        </div>
    )
}




export default MenuLinks
export { LogoutMenu }